/* eslint-disable */ 
import React, { useState } from 'react';
import './components.css';
import "../index.css";
import Form from './Form';
import { useStateValue } from '../ContextApi/StateProvider';

const NewExercise = (props) => {
    const [errors, setErrors] = useState([]);
    const [title, setTitle] = useState("");
    const [initialState, dispatch] = useStateValue();
    const authUser = JSON.parse(initialState.authenticatedUser);

    const submit = () => {
        let workoutId = parseInt(props.workoutId);
        const exercise = { title, workoutId };

        initialState.ExerciseRequests.createExercise(
            exercise,
            authUser.emailAddress,
            authUser.password
        )
        .then((response) => {
            if (response === "success") {
                console.log(`${authUser.emailAddress} has successfully created exercise ${exercise}`);
                dispatch({
                    type: 'SET_EXERCISE_FORM_OPEN',
                    exerciseFormOpen: false
                });
                props.updateFunction();
            } else if (response === "forbidden") {
                setErrors([...errors, "You must be logged in to create an exercise."]);
            } else {
                setErrors([...errors, response]);
                console.log(errors);
            }
        })
        .catch(err => {
            setErrors([...errors, err]);
        });
    };

    const change = (event, setState) => {
        const value = event.target.value;
        setState(value);
    };

    const cancel = () => {
        dispatch({
            type: 'SET_EXERCISE_FORM_OPEN',
            exerciseFormOpen: false
        });
    };

    return (
        <div className="container-2025 section-2025">
            <Form 
                cancel={cancel}
                cancelButtonText="Back"
                submit={submit}
                submitButtonText="Add Exercise"
                elements={() => (
                    <>
                        <h3 className="new-exercise-header">
                            <i className="fas fa-plus-circle"></i> Add Exercise
                        </h3>
                        {errors.map((error, i) => (
                            <p key={i} className="new-excercise-error-message">{error}</p>
                        ))}
                        <div className="form-row">
                            <label htmlFor="title" className="form-label">Exercise Name</label>
                            <input
                                id="title"
                                name="title"
                                type="text"
                                onChange={(e) => change(e, setTitle)} 
                                placeholder={title}
                                maxLength="18"
                                required
                                className="input-2025"
                            />
                        </div>
                    </>
                )}
            />
        </div>
    );
};

export default NewExercise;